import Axios from "axios";
import {
    SET_SIZE_LIST,
    UNSET_SIZE_LIST,
  } from "@/store/mutation-types";
import { saveUpdateSize, getSizeList } from "@/store/api";
// initial state
const state = {
  getSizeList: [],
};

const getters = {
  getSizeList(state) {
    return state.getSizeList;
  },
};

const mutations = {
  [SET_SIZE_LIST](state, data) {
    state.getSizeList = data;
  },
  [UNSET_SIZE_LIST](state) {
    state.getSizeList = [];
  }
};

const actions = {

  saveUpdateSize({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateSize, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getSizeList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getSizeList, data)
        .then(function (response) {
          commit('SET_SIZE_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_SIZE_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

};

export default {
  state,
  getters,
  actions,
  mutations,
};
